import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/map/216022/logo1.png';
import _imports_1 from '@/assets/map/216022/appindex.png';
const _withScopeId = n => (_pushScopeId("data-v-4b2ff024"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mapcontainer",
  id: "mapcontainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bgimg",
  src: _imports_1,
  alt: ""
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mprompt = _resolveComponent("mprompt");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_mprompt, {
    onClick: _cache[0] || (_cache[0] = $event => $data.promptboxFlag = false)
  }, null, 512), [[_vShow, $data.promptboxFlag]]), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.goDetail(item, index)
    }, null, 8, _hoisted_3);
  }), 128)), _hoisted_4])])], 64);
}